import { FolderSearch } from 'lucide-react'

export const EmptyWithDrawsTable = () => {
  return (
    <div className="flex h-[590px] w-full flex-col items-center justify-center rounded-xl border-[1px] border-[#E5E5E5]">
      <FolderSearch size={46} />
      <h2 className="mb-4 mt-2 text-xl font-semibold">
        Nenhum saque registrado{' '}
      </h2>
      <p className="w-[520px] text-center font-medium text-black04">
        Aqui será exibido o histórico de saques do usuário.
      </p>
    </div>
  )
}
